import { Outlet } from 'react-router-dom'
import { Providers } from '@/components/common/Providers'
import { Toaster } from 'sonner'

export function RootLayout() {
  return (
    <Providers>
      <Outlet />
      <Toaster richColors position="top-right" />
    </Providers>
  )
}
